<template>
  <button @click="newDoc" :aria-label="$t('sidebar.newDoc') || 'Nuevo documento'" :title="$t('sidebar.newDoc') || 'Nuevo documento'" class="action" id="new-doc-button">
    <file-text-icon size="1.5x" class="custom-class"></file-text-icon>
    <span>{{ $t('sidebar.newDoc') || 'Documento' }}</span>
  </button>
</template>

<script>
import { FileTextIcon } from 'vue-feather-icons';

export default {
  name: 'new-doc-button',
  components: {
    FileTextIcon,
  },
  methods: {
    newDoc () {
      this.$store.commit('showHover', { prompt: 'newFile', confirm: null, action: null, props: null, data: { fileType: 'docx' } });
    },
  },
};
</script>
